/* istanbul ignore next */
const ACTIONS = {
    PAYOUT_DETAILS_ERROR: 'PAYOUT_DETAILS_ERROR',
    GET_PAYOUT_METADATA: 'GET_PAYOUT_METADATA',
    GET_PAYOUT_METADATA_SUCCESS: 'GET_PAYOUT_METADATA_SUCCESS',
    PAYOUT_DETAILS_FIELD_ERROR: 'PAYOUT_DETAILS_FIELD_ERROR',
    TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON: 'TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX',
    HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE: 'HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE',
    SUBMIT_PAYOUT_DETAILS_FORM: 'SUBMIT_PAYOUT_DETAILS_FORM',
    SET_UNSUPPORTED_PAYOUT_COUNTRY: 'SET_UNSUPPORTED_PAYOUT_COUNTRY',
};

/* istanbul ignore next */
const ACTION_CREATORS = {

    toggleContinueButton(currency) {
        return {
            type: ACTIONS.TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON,
            payload: {
                currency
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.PAYOUT_DETAILS_ERROR,
            payload: {
                errorKey
            }
        };
    },

    setFieldError(fieldName, msg) {
        return {
            type: ACTIONS.PAYOUT_DETAILS_FIELD_ERROR,
            payload: {
                fieldName,
                msg
            }
        };
    },

    handleFieldValueChange(fieldName, fieldValue) {
        return {
            type: ACTIONS.HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    },

    setUnsupportedPayoutCountry(countryName) {
        return {
            type: ACTIONS.SET_UNSUPPORTED_PAYOUT_COUNTRY,
            payload: { countryName }
        };
    },

    getPayoutMetadata() {
        return {
            type: ACTIONS.GET_PAYOUT_METADATA
        };
    },

    getPayoutMetadataSuccess(payoutMetadata) {
        return {
            type: ACTIONS.GET_PAYOUT_METADATA_SUCCESS,
            payload: {
                bankingCountryList: payoutMetadata.bankingCountryList,
                countryList: payoutMetadata.countryList,
                userInfo: payoutMetadata.userInfo,
            }
        };
    },

    submitPayoutDetailsForm(siteName, bankingCountryCode, bankingState, currency) {
        return {
            type: ACTIONS.SUBMIT_PAYOUT_DETAILS_FORM,
            payload: {
                siteName,
                bankingCountryCode,
                bankingState,
                currency
            }
        };
    },
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
